export default "__VITE_ASSET__52fb3bb9__"